import { AppRemixIcon, AppSingleSelect } from '@/layout/AppComponents';
import BreadcrumbHandler from '@/layout/components/breadcrumb/BreadcrumbHandler';
import Translator from '@/layout/components/helpers/Translator';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import ReactDOMServer from 'react-dom/server';
import SelectPlants from '@/layout/components/form/Selects/SelectPlants';
import SelectPlantGroups from '@/layout/components/form/Selects/SelectPlantGroups';
import ReportOptionsSwitch from './ReportOptionsSwitch';
import ArchiveFile from './ArchieveFiles/ArchiveFile';
import ModalsGenerateReport from './ModalsGenerateReport';
import OnlineInfoSwitch from './OnlineInfoSwitch';
import IntelligenceModalProfileSave from './Profiles/IntelligenceModalProfileSave';
import IntelligenceModalProfileLoad from './Profiles/IntelligenceModalProfileLoad';

const Intelligence = () => {
  const module = useSelector((state) => state.currentPage?.module);

  const [startGenerateReport, setStartGenerateReport] = useState();
  const [onlineInfo, setOnlineInfo] = useState(null);

  // >> save profile
  const [showSaveProfileModal, setShowSaveProfileModal] = useState(false);
  const [valuesToProfile, setValuesToProfile] = useState(null);
  // <<

  const [formatOptions] = useState([
    {
      value: 'plants',
      label: ReactDOMServer.renderToString(
        <Translator file="user" name="user.plants" />,
      ),
    },
    {
      value: 'plantGroups',
      label: ReactDOMServer.renderToString(
        <Translator file="user" name="module.plantGroups" />,
      ),
    },
  ]);

  // >> FORMIK INTERFACE
  const handleOnGenerateReport = (values) => {
    setOnlineInfo(null);
    setStartGenerateReport(values);
  };

  const handleSelectReport = (value, resetForm, setFieldValue) => {
    resetForm();
    const sr = module.reports.find((r) => r.type.intReportId === value);
    setFieldValue('report', sr);
    setOnlineInfo(null);
  };

  const handleSelectFormat = (e, resetForm, setFieldValue, values) => {
    const { report } = values;
    resetForm();
    setFieldValue('report', report);
    setFieldValue('format', e);
    setOnlineInfo(null);
  };

  const handleResetForm = (resetForm) => {
    resetForm();
    setOnlineInfo(null);
  };
  // <<

  // >> PROFILE SAVE
  const handleShowSaveProfileModal = (status, values) => {
    setValuesToProfile(values);
    setShowSaveProfileModal(status);
  };
  // <<

  return (
    <>
      <BreadcrumbHandler paths={[{ name: module.name }]} />
      <section className="content">
        <div className="row m-0">
          <div className="col-8">
            <Formik
              // initialValues={defaultReportValues}
              initialValues={{}}
              onSubmit={handleOnGenerateReport}
              validationSchema={() =>
                Yup.lazy((values) => {
                  if (values.report?.type?.id === 44) {
                    return Yup.object().shape({
                      plants: Yup.array()
                        .min(1, 'Mínimo 1 instalación')
                        .max(50, 'Máximo 50 instalaciones'),
                      plantGroups: Yup.array()
                        .min(1, 'Mínimo 1 grupo de instalaciones')
                        .max(10, 'Máximo 10 grupos de instalaciones'),
                    });
                  }
                  return Yup.object();
                })
              }
              enableReinitialize
            >
              {({ setFieldValue, handleSubmit, values, resetForm, errors }) => (
                <div className="card">
                  <IntelligenceModalProfileLoad />
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <div className="row">
                          <div className="col-sm-12">
                            <AppSingleSelect
                              icon={<AppRemixIcon icon="file-list" />}
                              options={module.reports}
                              title={ReactDOMServer.renderToString(
                                <Translator
                                  file="module-intelligence"
                                  name="module.int.report-type"
                                />,
                              )}
                              placeholder={ReactDOMServer.renderToString(
                                <Translator
                                  file="module-intelligence"
                                  name="module.int.select-report"
                                />,
                              )}
                              value={values?.report?.type?.intReportId}
                              hasSearchBox
                              onChange={(opt) =>
                                handleSelectReport(opt, resetForm, setFieldValue)
                              }
                            />
                          </div>
                        </div>
                        {module.options.hidePlants != true &&
                          module.options.hidePlantGroups != true &&
                          values?.report?.type.settings.format.length > 1 && (
                            <div className="row">
                              <div className="col-sm-12">
                                <AppSingleSelect
                                  icon={<AppRemixIcon icon="layout-column" />}
                                  options={formatOptions}
                                  title={
                                    <Translator
                                      file="module-intelligence"
                                      name="format"
                                    />
                                  }
                                  placeholder={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-intelligence"
                                      name="select.an.option"
                                    />,
                                  )}
                                  value={values?.format}
                                  onChange={(e) =>
                                    handleSelectFormat(
                                      e,
                                      resetForm,
                                      setFieldValue,
                                      values,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          )}
                        {((values?.report?.type.settings.format.length == 1 &&
                          values?.report?.type.settings.format.includes('plants')) ||
                          values?.format === 'plants' ||
                          (values?.report?.type.settings.format.includes('plants') &&
                            module.options.hidePlantGroups == true)) && (
                          <div className="row">
                            <div className="col-lg-12">
                              <SelectPlants
                                type="userPlants"
                                format="m"
                                isSubmodule={
                                  !!values?.report?.type.settings?.isSubmodule
                                }
                                value={values.plants || []}
                                error={errors?.plants}
                                onHandleChange={(opt) => setFieldValue('plants', opt)}
                                isMulti
                              />
                            </div>
                          </div>
                        )}
                        {((values?.report?.type.settings.format.length == 1 &&
                          values?.report?.type.settings.format.includes(
                            'allPlants',
                          )) ||
                          values?.format === 'allPlants' ||
                          (values?.report?.type.settings.format.includes(
                            'allPlants',
                          ) &&
                            module.options.hidePlantGroups == true)) && (
                          <div className="row">
                            <div className="col-lg-12">
                              <SelectPlants
                                type="userPlantsWithoutObligations"
                                format="m"
                                isSubmodule={
                                  !!values?.report?.type.settings?.isSubmodule
                                }
                                value={values.plants}
                                error={errors?.plants}
                                onHandleChange={(opt) => setFieldValue('plants', opt)}
                                isMulti
                              />
                            </div>
                          </div>
                        )}
                        {((values?.report?.type.settings.format.length == 1 &&
                          values?.report?.type.settings.format.includes(
                            'plantGroups',
                          )) ||
                          values?.format === 'plantGroups' ||
                          (values?.report?.type.settings.format.includes(
                            'plantGroups',
                          ) &&
                            module.options.hidePlants == true)) && (
                          <div className="row">
                            <div className="col-lg-12">
                              <SelectPlantGroups
                                type="all"
                                onHandleChange={(opt) => {
                                  setFieldValue('plantGroups', opt);
                                }}
                                reset={!values.plantGroups}
                                error={errors?.plantGroups}
                              />
                            </div>
                          </div>
                        )}
                        {(values.plants ||
                          values.plantGroups ||
                          values?.report?.type.settings.format.length == 0) &&
                          values?.report && (
                            <>
                              <ReportOptionsSwitch
                                reportType={values?.report?.type.id}
                                handleOnSubmit={handleSubmit}
                                handleOnShowSaveProfileModal={(r) =>
                                  handleShowSaveProfileModal(r, values)
                                }
                                handleOnSetFieldValue={setFieldValue}
                                values={values}
                                errors={errors}
                                selectedReport={values?.report}
                              />
                              <IntelligenceModalProfileSave
                                showSaveProfileModal={showSaveProfileModal}
                                setShowSaveProfileModal={setShowSaveProfileModal}
                                valuesToProfile={valuesToProfile}
                              />
                            </>
                          )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 text-right mt-2">
                        {!values?.report ? (
                          <span className="btn btn-outline-light btn-xs disabled">
                            <AppRemixIcon icon="arrow-go-back" />
                            <Translator
                              file="module-intelligence"
                              name="report.restart"
                            />
                          </span>
                        ) : (
                          <span
                            className="btn btn-outline-light btn-xs"
                            onClick={() => handleResetForm(resetForm)}
                          >
                            <AppRemixIcon icon="arrow-go-back" />
                            <Translator
                              file="module-intelligence"
                              name="report.restart"
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <ModalsGenerateReport
            startGenerateReport={startGenerateReport}
            setStartGenerateReport={setStartGenerateReport}
            setOnlineInfo={setOnlineInfo}
          />
          <ArchiveFile />
        </div>
        {onlineInfo && <OnlineInfoSwitch data={onlineInfo} />}
      </section>
    </>
  );
};

export default Intelligence;
